import {Injectable} from '@angular/core';
import {NzDrawerRef, NzDrawerService} from 'ng-zorro-antd/drawer';

@Injectable()
export class AsideService {
    private openedAside: NzDrawerRef = null;

    constructor(
        private readonly drawerService: NzDrawerService,
    ) {
    }

    open(component, params?: any) {
        this.openedAside = this.drawerService.create({
            nzContent: component,
            nzContentParams: params,
            nzWidth: 'initial',
            nzKeyboard: false,
            nzClosable: false,
            nzMaskClosable: false,
        });
        return this.openedAside;
    }

    closeAside() {
        this.openedAside?.close();
    }
}
